import React, { Component } from 'react';
import { Row, Col, Table } from "react-bootstrap";
import { toast } from 'react-toastify';

import { CustomCard } from "../../components/Card/CustomCard";
import ModalForm from "../../components/Modal/ModalForm";

import { BusquedaEst, SolicitudesCambCarrera } from "../../funciones/EstudiantesFunction";

import EstudiantesTable from "./EstudiantesTable";
import EstInscripcion from "./EstInscripcion";
import CambioCarreraEst from './CambioCarreraEst';

class Estudiantes extends Component {
    state = {
        string: "",
        preloader: "",
        estudiantes: [],
        textTabla: "Ingresa una cédula, nombre o apellido para consultar",
        openW: false,
        idEst:"",
        nEst: "",
        estData: "",
        control: false,
        estCambio: [],
        preloader: {icon: "fa fa-spinner fa-spin", text: "Buscando Solicitudes Pendientes"}
    }

    componentDidMount = () => {
        SolicitudesCambCarrera ((resp) => {
            if (resp.length === 0) {
                this.setState({
                    estCambio: [],
                    preloader: {icon: "fa fa-times", text: "No hay solicitudes de cambio de carrera pendientes"}
                })
            }else{
                this.setState({
                    estCambio: resp
                })
            }
        })
    }

    cambiaValor = (prop) => (event) => {
        this.setState({
            [prop]: event.target.value 
        });
    };

    contenidoModal = () => (<EstInscripcion data= {this.state.estData} usu={this.state.usu} cerrar = {()=> this.cerrarModal()}/>)

    showModal = () => {
        const { openW, nEst, } = this.state;
        return (
            <ModalForm
                isopen =  {openW}
                titulo = {<div>{nEst}</div>}
                contenido = {this.contenidoModal()}
                cerrar = {this.cerrarModal}
            />
        );
    }

    openModal = (data, nombre) => {
        this.setState ({
            openW: true,
            estData: data,
            nEst: nombre,
            control: false,
        })
    }

    cerrarModal = () => {
        this.setState ({
            openW: false,
        })
    }

    ayuda = () => (
        <React.Fragment>
            <Row>
                <Col md={12} align="justify">
                    El módulo Opciones Estudiantes permite la inscripción de materias de la oferta académica disponible de cualquier estudiante. Para esto debes realizar los siguientes pasos:
                </Col>
                <Col md={12} className="custom-mt-10">
                    <strong style={{color:"#1f2f6e"}}>Paso 1:</strong>
                </Col>
                <Col md={12} align="justify">
                    Ingresa un dato del estudiante a consultar (cédula, nombre o apellido).
                </Col>
                <Col md={12} align="justify" className="custom-mt-10">
                    Verás un listado con todas las coincidencias de tu búsqueda con los siguientes datos:
                </Col>
                <Col md={12} align="justify" className="custom-mt-10" style={{paddingLeft:30, paddingRight:30, fontSize: 10}}>
                    <div><strong>C.I.</strong> Cédula del Estudiante</div>
                    <div><strong>Estudiante</strong> Nombres y Apellidos</div>
                    <div><strong>Carrera</strong> Carrera Inscrita</div>
                    <div><strong>Acciones</strong> Botón de Acciones</div>
                </Col>
                <Col md={12} className="custom-mt-10">
                    <strong style={{color:"#1f2f6e"}}>Paso 2:</strong>
                </Col>
                <Col md={12} align="justify">
                    Una vez seleccionado el estudiante presiona el botón <button className="btn btn-xs btn-primary" style={{borderWidth:1}}><i className="fa fa-mail-forward"></i> Inscripción</button> el cual te abrirá una ventana con las opciones de la inscripción.
                </Col>
                <Col md={12} className="custom-mt-10" align="justify">
                    En la ventana que se abrirá podrás ver la ayuda en la parte superior izquierda haciendo click en el botón <button className="btn btn-xs btn-warning" style={{borderWidth:1}}><i className="fa fa-question-circle-o"></i></button>
                </Col>
            </Row>
        </React.Fragment>
    )
    
    enterTab = () => (e) => {
        if (e.which === 13){
            if (this.state.string === "") return null;
            this.setState ({
                preloader: "fa fa-spinner fa-spin"
            }, () => {
                BusquedaEst (this.state.string, (resp) => {
                    
                    if (resp.length === 0) {
                        toast.error("No se encontró ninguna coincidencia",{autoClose: 4000});
                        this.setState ({
                            preloader: "",
                            textTabla: "La búsqueda no obtuvo resultados",
                            estudiantes: []
                        })
                        return null
                    }
                    this.setState ({
                        preloader: "",
                        estudiantes: resp
                    })
                })
            })
        }
    }


    consultaEst = () => {
        BusquedaEst (this.state.string, (resp) => {
                    
            if (resp.length === 0) {
                toast.error("No se encontró ninguna coincidencia",{autoClose: 4000});
                this.setState ({
                    preloader: "",
                    textTabla: "La búsqueda no obtuvo resultados",
                    estudiantes: []
                })
                return null
            }
            this.setState ({
                preloader: "",
                estudiantes: resp
            })
        })
    }



    lisEstudiantes = () => {
        let { estudiantes, textTabla } = this.state;

        if(estudiantes.length === 0) {
            return (
                <tr>
                    <td colSpan={4} align="center">{textTabla}</td>
                </tr> 
            )
        }else if(estudiantes.length > 0) {
            return(
                estudiantes.map(option => (
                    <EstudiantesTable
                    key={option.id_estudiante}
                    data={option}
                    verDatos = {(data, nombre) => {this.openModal(data, nombre)}}
                    boton = { this.state.boton }
                    consulta = {() => {this.consultaEst()}}
                    />
                ))
            )
        }else{
            return (
                <tr>
                    <td colSpan={4} align="center">{textTabla}</td>
                </tr> 
            )
        }
    }

    listCamCarrera = () => {
        let { estCambio, preloader } = this.state;

        if (estCambio.length === 0) return (
            <tr>
                <td colSpan={5} align="center"><i className = {preloader.icon}></i> {preloader.text}</td>
            </tr> 
        )

        return (
            estCambio.map(option => (
                <CambioCarreraEst key = {option.DataEst.id} data = {option} upd = {(data) => {
                    if (data.length === 0) {
                        this.setState({
                            estCambio: [],
                            preloader: {icon: "fa fa-times", text: "No hay solicitudes de cambio de carrera pendientes"}
                        })
                    }else{
                        this.setState({
                            estCambio: data
                        })
                    }
                }}/>
            ))
        )
    }

    render() {
        let { string, preloader } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        return (
            <div className="content">
                <Row>
                    <Col md={8}>
                        <div className="custom-alert-success" style={{padding: 5}}>
                            <div>Búsqueda de Estudiantes <i className={preloader}></i></div>
                            <input type="text" value ={string} onChange={this.cambiaValor("string")} onKeyPress={this.enterTab()} className="form-control" placeholder="Ingresa la C.I., nombre o apellido del estudiante"/>
                        </div>
                        <div className="table-responsive custom-mt-10" style={{backgroundColor:"#FFF"}}>
                        <Table striped hover bordered>
                            <tbody>
                                <tr className="custon-back-color">
                                    <td align="center" width="15%" style={styles}><strong>C.I.</strong></td>
                                    <td width="50%" style={styles}><strong>Estudiante</strong></td>
                                    <td align="center" width="35%" style={styles}><strong>Carrera</strong></td>
                                    <td align="center" width="100px" style={styles}><strong>Acciones</strong></td>
                                </tr>
                                {this.lisEstudiantes()}
                            </tbody>
                        </Table>
                        </div>
                        <div className = 'custom-mt-10'>
                            <div className = 'text-danger'>Solicitudes de Cambio de Carrera</div>
                            <Table striped hover bordered>
                                <tbody>
                                    <tr className="custon-back-color-warning">
                                        <td align="center" width="16%" style={styles}><strong>C.I.</strong></td>
                                        <td width="50%" style={styles}><strong>Estudiante</strong></td>
                                        <td align="center" width="17%" style={styles}><strong>Carrera Actual</strong></td>
                                        <td align="center" width="17%" style={styles}><strong>Solicitud A</strong></td>
                                        <td align="center" width="100px" style={styles}><strong>Acciones</strong></td>
                                    </tr>
                                    {this.listCamCarrera()}
                                </tbody>
                            </Table>
                        </div>
                    </Col>
                    <Col md={4}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>Estudiantes</span>}
                                color="#a80012"
                                content={this.ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
                {this.showModal()}
            </div>
        );
    }
}
 
export default Estudiantes;


// WEBPACK FOOTER //
// ./src/views/Registros/Estudiantes.jsx